import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useCapitalDecreaseModal } from '../context/CapitalDecreaseModalContext';

const CapitalDecreaseModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useCapitalDecreaseModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">{t('CapitalReduction')}&nbsp;</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default CapitalDecreaseModalHeader;
